import { motion } from "framer-motion";
import { Video, CalendarDays, Clock, ArrowRight, Sparkles } from "lucide-react";
import { REGISTRATION_URL } from "./data";

const HERO_BG = "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=2000&q=80";

const highlights = [
    { icon: Video, label: "Live Online Class via Zoom" },
    { icon: CalendarDays, label: "Minggu, 15 November 2026" },
    { icon: Clock, label: "10.00–14.00 WIB" },
];

export const Hero = () => (
    <section id="hero" className="relative overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0">
            <img src={HERO_BG} alt="Properti premium di malam hari" className="h-full w-full object-cover" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#071B37] via-[#071B37]/92 to-[#123E65]/70" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#071B37] via-transparent to-[#071B37]/60" />
        </div>
        <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 pb-20 pt-16 lg:grid-cols-[1.15fr_0.85fr] lg:px-8 lg:pb-28 lg:pt-24">
            <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut" }}>
                <p className="mb-5 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#DDB56C] sm:text-sm" data-testid="hero-eyebrow">
                    <Sparkles className="h-4 w-4" strokeWidth={1.5} />
                    Cici Developer Presents — Exclusive KPR Masterclass
                </p>
                <h1 className="text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="hero-headline">
                    KPR ANTI BONCOS,{" "}
                    <span className="font-accent italic text-gold-gradient">Ini Rahasianya!</span>
                </h1>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg" data-testid="hero-subheadline">
                    Mau punya rumah tanpa salah strategi KPR? Pelajari cara memilih skema angsuran, memahami biaya yang sering terlewat, hingga strategi pelunasan dan take over KPR langsung dari praktisi properti.
                </p>
                <div className="mt-7 flex flex-wrap gap-3" data-testid="hero-highlights">
                    {highlights.map((h) => (
                        <span key={h.label} className="inline-flex items-center gap-2 rounded-full border border-[#DDB56C]/30 bg-white/5 px-4 py-2 text-xs font-medium text-white/90 backdrop-blur-sm sm:text-sm">
                            <h.icon className="h-4 w-4 text-[#DDB56C]" strokeWidth={1.5} />
                            {h.label}
                        </span>
                    ))}
                </div>
                <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
                    <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-primary-cta"
                        className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#DDB56C] px-8 py-4 text-base font-bold text-[#071B37] shadow-[0_8px_32px_rgba(221,181,108,0.4)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#e9cf9a] hover:shadow-[0_12px_40px_rgba(221,181,108,0.55)]">
                        Saya Mau Ikut Kelas!
                        <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
                    </a>
                    <a href="#materi" data-testid="hero-secondary-cta"
                        className="inline-flex items-center justify-center rounded-full border border-white/25 px-8 py-4 text-base font-semibold text-white transition-colors duration-300 hover:border-[#DDB56C]/60 hover:text-[#DDB56C]">
                        Lihat Materi Kelas
                    </a>
                </div>
                <p className="mt-6 text-xs text-white/55 sm:text-sm" data-testid="hero-microcopy">
                    Belajar langsung dari praktisi properti • Materi eksklusif • E-Sertifikat
                </p>
            </motion.div>
            <motion.div initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, delay: 0.2, ease: "easeOut" }}
                className="relative mx-auto w-full max-w-sm lg:max-w-none">
                <div className="absolute -inset-3 rounded-[2rem] border border-[#DDB56C]/35" />
                <div className="relative overflow-hidden rounded-[1.75rem] shadow-[0_24px_64px_rgba(0,0,0,0.5)]">
                    <img src="/assets/portrait-cici.webp" alt="Priscillia Ester — Cici Developer" className="aspect-[5/6] w-full object-cover object-top" data-testid="hero-portrait" />
                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#071B37]/90 to-transparent p-5 pt-14">
                        <p className="font-accent text-lg font-semibold text-white">Priscillia Ester, S.T., M.M.</p>
                        <p className="text-xs text-[#DDB56C]">CEO of Spark Residence, Property Deals, Legal Pro</p>
                    </div>
                </div>
            </motion.div>
        </div>
    </section>
);
